export default function parseSystemMsg(text) {
  let wrapDom = document.createElement("template");
  wrapDom.innerHTML = text;

  var title = wrapDom.content.querySelector("h1,h2,h3,h4");
  if (title) title = title.innerText.trim();

  var desc = getDesc(wrapDom.content);
  if (!desc) desc = wrapDom.innerText || "";

  if (desc.length > 40) {
    desc = desc.slice(0, 40);
    desc += "……";
  }

  return {
    title,
    desc,
  };
}
/**
 *
 * @param {Element} el
 * @returns
 */
function getDesc(el) {
  var elements = el.children;
  var text = "";
  for (var i = 0; i < elements.length; i++) {
    var element = elements[i];
    // 正文内容去除标题
    if (["H1", "H2", "H3"].includes(element.nodeName)) continue;
    var elementText = element.innerText.trim();
    text += elementText;
  }
  return text;
}
